import { render, staticRenderFns } from "./screening-task.vue?vue&type=template&id=5a5f5fae&scoped=true"
import script from "./screening-task.vue?vue&type=script&lang=js"
export * from "./screening-task.vue?vue&type=script&lang=js"
import style0 from "./screening-task.vue?vue&type=style&index=0&id=5a5f5fae&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a5f5fae",
  null
  
)

export default component.exports